"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment, useQuery } from "@opensea/graphql";
import { useChainArch, useCreateCollectionOfferFlow } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { useCollectionOffersFragment } from "./use-collection-offers.fragment";
export const useCollectionOffers = (collectionKey, {
  trait,
  traits,
  initialPrice
} = {}) => {
  const t = useTranslations("useCollectionOffers");
  const collection = readFragment(useCollectionOffersFragment, collectionKey);
  const createCollectionOfferFlow = useCreateCollectionOfferFlow();
  const chainArch = useChainArch();
  const getDisabledReason = () => {
    if (collection?.__typename === "Collection" && collection.chain.arch !== chainArch) {
      return t("errors.differentChainArch");
    }
    if (collection?.__typename === "DelistedCollection" || collection?.__typename === "BlacklistedCollection") {
      return t("errors.tradingDisabled");
    }
    if (!collection?.flags.isOffersEnabled) {
      return t("errors.cannotMakeCollectionOffersOnThisCollection");
    }
    return undefined;
  };
  const disabledReason = getDisabledReason();
  const disabled = Boolean(disabledReason);
  const createCollectionOffer = () => {
    if (collection?.__typename === "Collection") {
      createCollectionOfferFlow(collection.slug, {
        trait: collection.traitOffersEnabled ? trait : undefined,
        traits: collection.traitOffersEnabled ? traits : undefined,
        initialPrice,
        chain: collection.chain.identifier
      });
    }
  };
  return {
    disabled,
    disabledReason,
    createCollectionOffer
  };
};
const query = graphql(`
    query useCollectionOffersFromSlug($slug: String!) {
      collectionBySlug(slug: $slug) {
        ...useCollectionOffers
      }
    }
  `, [useCollectionOffersFragment]);
export const useCollectionOffersFromSlug = slug => {
  const $ = _c(5);
  const t0 = slug ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      slug: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !slug;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      query,
      variables: t1,
      pause: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [t4] = useQuery(t3);
  const {
    data
  } = t4;
  return useCollectionOffers(data?.collectionBySlug);
};